exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#no_login[data-v-0e313958]{height:70%;text-align:center;padding-top:15%}.to_login[data-v-0e313958]{width:100%;height:20%}a[data-v-0e313958]{text-decoration:none;color:#8a2be2}select[data-v-0e313958]{width:40%}#CollCourse[data-v-0e313958],#CollVideo[data-v-0e313958]{height:25px;line-height:25px;font-size:20px}#courseCatalog[data-v-0e313958],#videoCatalog[data-v-0e313958]{background-color:ivory}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0e313958","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Index/Course/Collection.vue
// module id = hXut
// module chunks = 1